"use strict";
// Styles for use in the lineage/metadata info pane.
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasourceListSection = exports.DetailsPaneSection = exports.SheetFieldListElementContainer = exports.SheetFieldsListBody = exports.DatasourceIconNameContainer = exports.DataQualityWarningIconWrapper = exports.DatasourceListBodyElement = exports.DatasourceListBody = exports.DatasourcesSectionHeader = exports.FieldsSectionHeader = exports.SparklineHeader = exports.HeaderWrapper = exports.lineagePanelBodyWithError = exports.lineagePanelBody = exports.TitleTextCssClass = exports.TitleBarContainer = exports.loadingIndicator = exports.LoadingErrorCode = exports.LoadingErrorMessage = exports.LineagePanelContainer = exports.dataDetailsContentWidth = exports.dataDetailsGutterWidth = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var Colors = widgets_1.TabStyles.Colors;
var Spacing = widgets_1.TabStyles.Spacing;
var Sizing = widgets_1.TabStyles.Sizing;
var Typography = widgets_1.TabStyles.Typography;
exports.dataDetailsGutterWidth = 20;
exports.dataDetailsContentWidth = 281;
var lineagePanelContainerStyles = {
    position: 'absolute',
    top: '0px',
    bottom: '0px',
    left: '0px',
    right: '0px',
    borderLeftStyle: 'solid',
    borderLeftWidth: Sizing.BorderWidth,
    borderLeftColor: Colors.L6,
    backgroundColor: Colors.White,
    color: Typography.Color.Primary,
    $nest: {
        'a': {
            textDecoration: 'none',
            outline: 0,
            color: data_catalog_shared_1.AccessibleHyperLinkBlue,
            $nest: {
                '&:hover': {
                    textDecoration: 'underline',
                    color: data_catalog_shared_1.AccessibleHyperLinkBlueHover
                },
                '&:focus': {
                    textDecoration: 'underline',
                    color: data_catalog_shared_1.AccessibleHyperLinkBlueFocus
                }
            }
        }
    }
};
exports.LineagePanelContainer = (0, data_catalog_shared_1.divWithStyle)('lineagePanel', lineagePanelContainerStyles);
exports.LoadingErrorMessage = (0, data_catalog_shared_1.divWithStyle)('loadingErrorMessage', {
    marginTop: widgets_1.TabStyles.Spacing.LargeSpace,
    marginBottom: widgets_1.TabStyles.Spacing.MediumSpace,
    color: Typography.Color.Primary,
    fontSize: Typography.Sizing.Default,
    whiteSpace: 'pre-line'
});
exports.LoadingErrorCode = (0, data_catalog_shared_1.divWithStyle)('loadingErrorCode', {
    marginBottom: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
    color: Typography.Color.Secondary,
    fontSize: Typography.Sizing.Small
});
exports.loadingIndicator = (0, data_catalog_shared_1.cssClass)('loadingIndicator', {
    textAlign: 'center',
    margin: Spacing.ExtraLargeSpace,
    marginTop: '84px',
    fontFamily: Typography.FontFamily,
    color: Typography.Color.Primary
});
// Sizing constants are potentially undefined.
var TitleBarHeight = Sizing.RowHeight || 0;
var TitleBarPaddingTop = Spacing.SmallSpace || 0;
var TitleBarPaddingBottom = Spacing.SmallSpace || 0;
var TitleBarBorderBottomWidth = 1;
exports.TitleBarContainer = (0, data_catalog_shared_1.divWithStyle)('titleBarContainer', {
    paddingTop: TitleBarPaddingTop,
    paddingBottom: TitleBarPaddingBottom,
    paddingLeft: Spacing.MediumSpace,
    paddingRight: Spacing.MediumSpace,
    height: TitleBarHeight,
    display: 'flex',
    justifyContent: 'space-between',
    // Common header styles
    borderBottomColor: Colors.F5,
    borderBottomStyle: 'solid',
    borderBottomWidth: TitleBarBorderBottomWidth,
    backgroundColor: Colors.F1
});
exports.TitleTextCssClass = (0, data_catalog_shared_1.cssClass)('titleText', {
    paddingLeft: Spacing.DefaultSpace,
    alignSelf: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: Typography.Sizing.Default,
    fontWeight: 'normal',
    marginBottom: '0px',
    marginRight: 'auto',
    marginTop: '0px'
});
var lineagePanelBodyStyles = __assign(__assign({}, data_catalog_shared_1.userSelectStyle), { paddingTop: Spacing.LargeSpace, lineHeight: 1.5, position: 'absolute', top: TitleBarHeight + TitleBarPaddingTop + TitleBarPaddingBottom + TitleBarBorderBottomWidth, bottom: 0, left: 0, right: 0, overflowX: 'hidden' });
exports.lineagePanelBody = (0, data_catalog_shared_1.cssClass)('lineagePanelBody', lineagePanelBodyStyles);
exports.lineagePanelBodyWithError = (0, data_catalog_shared_1.cssClass)('lineagePanelBodyWithError', __assign(__assign({}, lineagePanelBodyStyles), { 
    // Special one-off top margin per UX design
    paddingLeft: Spacing.LargeSpace, paddingRight: Spacing.LargeSpace, marginTop: '100px', textAlign: 'center' }));
exports.HeaderWrapper = (0, data_catalog_shared_1.divWithStyle)('headerWrapper', {
    paddingLeft: exports.dataDetailsGutterWidth,
    paddingRight: exports.dataDetailsGutterWidth,
    width: exports.dataDetailsContentWidth,
});
exports.SparklineHeader = (0, data_catalog_shared_1.divWithStyle)('sparklineHeader', {
    color: Typography.Color.Primary,
    marginBottom: Spacing.DefaultSpace,
});
exports.FieldsSectionHeader = (0, data_catalog_shared_1.divWithStyle)('fieldsSectionHeader', {
    color: Typography.Color.Primary,
    marginBottom: Spacing.MediumSpace,
}, { role: 'heading', 'aria-level': 4 });
exports.DatasourcesSectionHeader = (0, data_catalog_shared_1.divWithStyle)('datasourcesSectionHeader', {
    color: Typography.Color.Primary,
    paddingBottom: Spacing.DefaultSpace,
}, { role: 'heading', 'aria-level': 4 });
exports.DatasourceListBody = (0, data_catalog_shared_1.divWithStyle)('DatasourceListBody', {
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingRight: exports.dataDetailsGutterWidth,
});
exports.DatasourceListBodyElement = (0, data_catalog_shared_1.divWithStyle)('DatasourceListBodyElement', {
    border: "".concat(Sizing.BorderWidth, "px solid ").concat(Colors.L6),
    padding: Spacing.DefaultSpace,
    marginTop: Spacing.DefaultSpace,
    marginBottom: Spacing.MediumSpace,
    borderRadius: 1,
});
exports.DataQualityWarningIconWrapper = (0, data_catalog_shared_1.divWithStyle)('DataQualityWarningIconWrapper', {
    paddingTop: 2
});
exports.DatasourceIconNameContainer = (0, data_catalog_shared_1.divWithStyle)('DatasourceIconNameContainer', {
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: Spacing.DefaultSpace
});
exports.SheetFieldsListBody = (0, data_catalog_shared_1.divWithStyle)('SheetFieldsListBody', {});
exports.SheetFieldListElementContainer = (0, data_catalog_shared_1.divWithStyle)('SheetFieldListElementContainer', {
    paddingBottom: Spacing.SmallSpace,
});
exports.DetailsPaneSection = (0, data_catalog_shared_1.divWithStyle)('DetailsPaneSection', {
    flex: 'none',
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: Spacing.ExtraLargeSpace,
    paddingLeft: exports.dataDetailsGutterWidth,
    paddingTop: Spacing.LargeSpace,
    paddingRight: exports.dataDetailsGutterWidth,
    width: exports.dataDetailsContentWidth
});
exports.DatasourceListSection = (0, data_catalog_shared_1.divWithStyle)('DatasourceListSection', {
    flex: 'none',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: exports.dataDetailsGutterWidth,
    paddingTop: Spacing.LargeSpace,
    borderTop: "1px solid ".concat(Colors.L6),
    borderBottom: "1px solid ".concat(Colors.L6),
    marginTop: Spacing.MediumSpace,
    overflow: 'visible'
});
//# sourceMappingURL=ViewerPaneStyles.js.map